<app-content-header [stepsBack]="2"
  [headline]="'phonenumber_selected_numbers' | i18next: {selected: selectedPhoneNumber ? 1 : 0, max: 1}">
</app-content-header>

<div class="row align-items-stretch mt-2">
  @for (b of blocks; track b) {
    <app-select-loc-ind-phonenumber-card
      [blockOffer]="b"
      [isSelected]="b.blockId === selectedPhoneNumber"
      (toggle)="onSelectionChange($event)" class="col-xs-12 col-xl-4 mb-3" >
    </app-select-loc-ind-phonenumber-card>
  }
</div>

<div class="d-flex justify-content-end p-3">
  <div class="row">
    <button class="btn btn-outline-primary" [disabled]="selectedPhoneNumber === ''" (click)="select()">{{'app_next' | i18next}}</button>
  </div>
</div>
